import { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import UIApplication from 'UIComponents/app/UIApplication';
import { AppContextProvider } from 'automation-ui-core/context/AppContext';
import { redirectToOtherWorkflowsApp } from 'automation-ui-routing/routerUtils';
import auth from 'automation-ui-canvas/utils/Auth';
import Routes from 'automation-ui-canvas/constants/Routes';
import NoAccess from 'automation-ui-canvas/components/errors/NoAccess';
import { upgradeToWorkflows } from 'automation-ui-references/routing/hubspotUrls';
import { ObjectTypePropertiesProvider } from 'automation-ui-references/object-type-properties/ObjectTypePropertiesContext';
import FlowContainer from 'automation-ui-canvas/containers/FlowContainer';
import CreateContainer from 'automation-ui-canvas/containers/CreateContainer';
import ClassicWorkflowRedirect from 'automation-ui-canvas/containers/ClassicWorkflowRedirect';
import { wireObjectTypeSupportsCustomProperties } from 'automation-ui-action-features/object-types/AllObjectTypesQuery';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import { initializeFullstory } from 'data-ops-fullstory';
import { AppConfigProvider } from 'automation-ui-source-apps/context/AppConfigContext';
import { workflowsAppDefaults } from 'automation-ui-source-apps/config/defaults/WorkflowsAppDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class Application extends Component {
  componentDidMount() {
    initializeFullstory({
      appKey: 'AutomationCanvas',
      identityVariables: {
        features: {
          isOptedIntoRedesign: true
        }
      }
    }).catch(() => {});
  }
  hubHasWorkflowAccess() {
    return auth.hubHasWorkflowsAccess();
  }
  userHasWorkflowAccess() {
    return auth.userHasWorkflowsAccess();
  }
  shouldRenderNoAccess() {
    return this.hubHasWorkflowAccess() && !this.userHasWorkflowAccess();
  }
  renderNoAccess() {
    return /*#__PURE__*/_jsx(NoAccess, {});
  }
  renderUpgradeToWorkflows() {
    window.location = upgradeToWorkflows();
    return null;
  }
  render() {
    const {
      supportsCustomProperties
    } = this.props;
    const contextualEmbedInfo = {
      contextualEmbedReadOnly: false,
      contextualEmbedReadOnlyMode: null,
      isContextualEmbed: false,
      triggerContent: null,
      sourceApp: WORKFLOWS_APP
    };
    return /*#__PURE__*/_jsx(AppContextProvider, {
      value: contextualEmbedInfo,
      children: /*#__PURE__*/_jsx(AppConfigProvider, {
        value: {
          config: workflowsAppDefaults,
          isEmbedded: false
        },
        children: /*#__PURE__*/_jsx(ObjectTypePropertiesProvider, {
          value: {
            embedId: '',
            isEmbedded: false,
            supportsCustomProperties
          },
          children: /*#__PURE__*/_jsx(UIApplication, {
            name: "automation-ui-canvas",
            className: "workflows-ui",
            "data-test-id": "workflows-root",
            children: this.shouldRenderNoAccess() ? this.renderNoAccess() : /*#__PURE__*/_jsxs(Switch, {
              children: [!this.hubHasWorkflowAccess() && /*#__PURE__*/_jsx(Route, {
                path: "*",
                render: this.renderUpgradeToWorkflows
              }), /*#__PURE__*/_jsx(Route, {
                path: Routes.PLATFORM_FLOW_REVISION,
                component: FlowContainer
              }), /*#__PURE__*/_jsx(Route, {
                path: Routes.FLOW_CONTAINER,
                component: FlowContainer
              }), /*#__PURE__*/_jsx(Route, {
                path: Routes.PLATFORM_FLOW,
                component: FlowContainer
              }), /*#__PURE__*/_jsx(Route, {
                path: Routes.CREATE_FLOW_FROM_CANVAS,
                component: CreateContainer
              }), /*#__PURE__*/_jsx(Route, {
                path: Routes.SINGLE_WORKFLOW,
                component: ClassicWorkflowRedirect
              }), /*#__PURE__*/_jsx(Route, {
                path: "*"
                // @ts-expect-error not sure yet
                ,
                render: redirectToOtherWorkflowsApp
              })]
            })
          })
        })
      })
    });
  }
}
export default wireObjectTypeSupportsCustomProperties(Application);